import { TeacherLocationSelector } from "@/pages/profiel/TeacherLocationSelector"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/medewerkers/$userId/leslocaties/",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { userId } = useParams({
    from: "/beheer/medewerkers/$userId/leslocaties/",
  })

  return <TeacherLocationSelector userId={Number(userId)} readOnly />
}
